/** @file frameSelectionEvent: the window event name "Frame" in a node menu fires (the viewport listens). */

/** `CustomEvent` on `window` with `detail: { node }`; for now only the menu fires it. */
export const frameSelectionEvent = 'pose3d:frame-selection';
